import { useQuery } from "@tanstack/react-query";
import { landlordSurveyApi } from "api/landlord-surveys/landlord-surveys";
import { useAuthContext } from "providers/Auth";
import { Layout } from "providers/Layout";
import { ScreeningTemplatesHeader } from "shared/app/ScreeningTemplatesHeader";
import { Redirect } from "shared/components/Redirect";
import { BuildSurveyCard } from "./components/BuildSurveyCard";
import { SurveyCard } from "./components/SurveyCard";
import { SurveyCardSkeleton } from "./components/SurveyCardSkeleton";
import { FEATURES } from "types/landlord/partner";

export const LandlordSurveysView = () => {
  const { type, partner } = useAuthContext();

  const isAvailable =
    type.isBoomScreen &&
    partner?.features.includes(FEATURES.WIP_FEAT_PREMIUM_RENTAL_VERIFICATION);

  const landlordSurveysList = useQuery({
    queryFn: landlordSurveyApi.getSurveys,
    queryKey: ["LANDLORD_SURVEYS"],
    enabled: isAvailable
  });

  if (!isAvailable) return <Redirect href="/" />;

  const surveysCount = landlordSurveysList.data?.length ?? 0;

  return (
    <Layout
      headerClassName="pb-0 border-b border-alpha-40 pt-6"
      header={
        <>
          <ScreeningTemplatesHeader />
          <div className="border-b border-alpha-100 bg-content-1000-inverted py-4 px-6">
            <h2 className="text-xl font-bold leading-tight text-content-1000">
              Survey templates
            </h2>
            <p className="mt-1 max-w-3xl text-base leading-normal text-content-400">
              Rental history survey completed by previous landlords to help you
              assess the tenant&apos;s suitability.
              <br />
              Create a custom survey with our survey builder.
            </p>
          </div>
        </>
      }
    >
      <div className="grid min-w-0 grid-cols-1 gap-4 pb-8 md:grid-cols-2 xl:grid-cols-3">
        <BuildSurveyCard to="/landlord-surveys/add" />
        {landlordSurveysList.isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
              <SurveyCardSkeleton key={`survey-skeleton-${i}`} />
            ))
          : (landlordSurveysList.data ?? []).map((survey) => (
              <SurveyCard
                key={survey.id}
                {...survey}
                surveysCount={surveysCount}
              />
            ))}
      </div>
    </Layout>
  );
};
